import * as yup from 'yup';

export const patientValidationSchma = {
  name: yup
    .string()
    .min(4, 'Too Short Name!')
    .max(50, 'Too Long Name!')
    .required('Fullname is required!'),
  email: yup.string().email().required('Email address is required!'),
  fileID: yup.string(),
  birthdate: yup.string().required('Birthdate is required!'),
  gender: yup.string().required('Gender is required!')
};

export const patientCreateValidationSchma = {
  name: yup
    .string()
    .min(4, 'Too Short Name!')
    .max(50, 'Too Long Name!')
    .required('Fullname is required!'),
  email: yup.string().email().required('Email address is required!'),
  password: yup.string().required('Password is required!'),
  fileID: yup.string(),
  birthdate: yup.string().required('Birthdate is required!'),
  gender: yup.string().required('Gender is required!')
};

export const goalsValidationSchma = yup
  .object()
  .shape({
    date: yup.date().required('Date is required'),
    HBA1C: yup.number().nullable(),
    weight: yup.number().nullable()
  })
  .test(
    'at-least-one',
    'At least one of HBA1C or weight must be provided',
    value => {
      if (value.HBA1C == null && value.weight == null) {
        return new yup.ValidationError(
          'At least one of HBA1C or weight must be provided',
          value,
          'HBA1C'
        );
      }
      return true;
    }
  );
